import { render, staticRenderFns } from "./DuplicationStatusIndicator.vue?vue&type=template&id=7a0ac1dc&"
import script from "./DuplicationStatusIndicator.vue?vue&type=script&lang=ts&"
export * from "./DuplicationStatusIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports